import { HeaderNavigationModel } from '@/types';
import classNames from 'classnames';
import XLight from '@/assets/xLight.svg';
import ArrowRightLight from '@/assets/arrowRightLight.svg';
import { Link } from '@/components';
import { useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { removeLinkQueryParams } from '@/utils';
import Lock from '@/assets/lock.svg';
type MobileNavAppSubmenuModel = {
  menu?: HeaderNavigationModel | null;
  closeNav: () => void;
  closeSubNav: () => void;
};

const MobileNavAppSubmenu = ({ menu, closeSubNav, closeNav }: MobileNavAppSubmenuModel) => {
  const [activeColumnIndex, setActiveColumnIndex] = useState<number | null>(null);

  const { asPath } = useRouter();

  const columns = [
    ...(menu?.props.column1NavigationItems ?? []),
    ...(menu?.props.column2NavigationItems ?? []),
    ...(menu?.props.column3NavigationItems ?? []),
  ].flat();

  const currentPath = useMemo(() => {
    return removeLinkQueryParams(asPath);
  }, [asPath]);

  return (
    <div
      className={classNames(
        'absolute top-0 flex h-full w-full flex-col justify-center overflow-auto bg-white transition-transform duration-300 ease-out',
        menu ? 'translate-x-0' : 'translate-x-full',
      )}
    >
      <div className="container flex h-14 shrink-0 items-center justify-between">
        <button className="flex items-center gap-2" onClick={closeSubNav}>
          <ArrowRightLight className="h-7 w-7 rotate-180" />
          <span className="text-lg font-bold">{menu?.props.label}</span>
        </button>
        <button className="flex h-8 w-8 items-center justify-center rounded-full" onClick={closeNav}>
          <XLight className="h-7 w-7" />
        </button>
      </div>
      <div className="container flex h-full flex-col overflow-auto pt-2">
        {columns.length === 1
          ? columns[0].props.navigationItems.map((navigationItem, index) => (
              <Link
                key={index}
                link={navigationItem.link}
                className={classNames(
                  'py-3.5 text-sm font-bold',
                  navigationItem.locked && 'opacity-50',
                  currentPath === navigationItem.link.href && 'underline',
                )}
              >
                {navigationItem.link.text} {navigationItem.locked && <Lock className="inline-block h-4 w-4" />}
              </Link>
            ))
          : columns?.map((column, index) => (
              <div key={index} className="">
                <button
                  className="w-full py-3 text-left text-lg font-bold"
                  onClick={() => setActiveColumnIndex(activeColumnIndex === index ? null : index)}
                >
                  {column.props.title}
                </button>
                <div
                  className={classNames(
                    'flex flex-col transition-all duration-500 ease-out',
                    activeColumnIndex === index ? 'max-h-[1000px]' : 'max-h-0 overflow-hidden',
                  )}
                >
                  {column.props.navigationItems.map((navigationItem, subIndex) => (
                    <Link
                      key={`${index}-${subIndex}`}
                      link={navigationItem.link}
                      className={classNames(
                        'py-2 text-sm last:mb-4',
                        currentPath === navigationItem.link.href && 'underline',
                      )}
                    />
                  ))}
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default MobileNavAppSubmenu;
